import {db} from "@/main";
import {
    FirestoreDataConverter,
    collection,
    getDocs,
    setDoc,
    doc, getDoc
} from "firebase/firestore";

const shiftSettingsConverter: FirestoreDataConverter<ShiftSettings> = {
    toFirestore(data: ShiftSettings) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        if(data.limitFreeDaysInTwoWeeks === undefined) {
            data.limitFreeDaysInTwoWeeks = true;
        }
        
        return { ...data, } as ShiftSettings;
    }
};

export function createDefaultShiftSettings(): ShiftSettings {
    return {
      displayName: '',
      shiftNr: '',
      default: true,
      schematasEnabled: true,
      schematas: [],
      shiftsEnabled: true,
      shifts: [
        { id: "1", nr: "1", active: true, name: "", max: 0},
        { id: "2", nr: "2", active: true, name: "", max: 0},
        { id: "3", nr: "3", active: true, name: "", max: 0},
        { id: "4", nr: "4", active: true, name: "", max: 0},
        { id: "5", nr: "5", active: true, name: "", max: 0},
        { id: "10", nr: "10", active: true, name: "", max: 0}
      ],
      freeDaysEnabled: true,
      freeDays: [
        { id: "friday", nr: "", active: true, name: "Freitag", max: 0},
        { id: "saturday", nr: "", active: true, name: "Samstag", max: 0},
        { id: "sunday", nr: "", active: true, name: "Sonntag", max: 0},
        { id: "monday", nr: "", active: true, name: "Montag", max: 0}
      ],
      reliefDaysEnabled: true,
      reliefDays: [
        { id: "et", nr: "", active: true, name: "Entlastungstage", max: 0},
      ],
      miscEnabled: true,
      misc: [
        { id: "maxConsecutiveWorkdays", nr: "", active: true, name: "Aneinanderfolgende Arbeitstage", max: 0},
      ],
      limitFreeDaysInTwoWeeks: true,
    };
};

export function GetShiftSettings(): Promise<ShiftSettings[]> {
    return new Promise<ShiftSettings[]>(async (resolve, reject) => {
        try {
            const shiftSettingsRef = collection(db, "shiftSettings").withConverter(shiftSettingsConverter);
            const shiftSettings: ShiftSettings[] = [];
            
            getDocs(shiftSettingsRef)
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        shiftSettings.push(doc.data());
                    });
                    resolve(shiftSettings);
                })
                .catch((error) => {
                    reject(`Error fetching shiftSettings: ${error}`);
                });
            
        } catch (error) {
            reject(error);
        }
})}

export function GetShiftSetting(shiftNr:string): Promise<ShiftSettings> {
    return new Promise<ShiftSettings>(async (resolve, reject) => {
        try {
            const shiftSettingRef =  doc(db, "shiftSettings", shiftNr).withConverter(shiftSettingsConverter);
            const shiftSettingSnapshot = await getDoc(shiftSettingRef);

            if(shiftSettingSnapshot.exists()) {
                resolve(shiftSettingSnapshot.data() as ShiftSettings);
            }
            else{
                reject();
            }

        } catch (error) {
            reject(error);
        }
    })}

export function SetShiftSettings(shiftSettings: ShiftSettings): Promise<void> {
    return setDoc(doc(db, "shiftSettings", shiftSettings.shiftNr), shiftSettings, { merge: true });
}
